import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    name: 'PlaylistItemsPanel',
  };

import { computed, ref } from 'vue';
  import { useStore } from '@/store';

  import PlaylistPreview from '@/components/layoutDesigner/editor/settingPanel/playlist/PlaylistPreview.vue';
  import LayoutPlaylistItems from '@/components/layoutDesigner/editor/settingPanel/playlist/LayoutPlaylistItems.vue';

  import {
    LAYOUT_DESIGNER_UPDATE_WIDGET,
    SET_PLAYLIST_ITEMS_PANEL,
  } from '@/store/actions/layoutDesigner';

  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const store = useStore();
  const PlaylistItems = ref<HTMLVideoElement | null>(null);

  const playlist = computed(function () {
    return store.state.layoutDesigner.selectedWidget;
  });

  function handleChange() {
    store.commit(LAYOUT_DESIGNER_UPDATE_WIDGET, { widget: playlist.value, selectWidget: false });
  }

  function goBackToPlaylist() {
    store.commit(SET_PLAYLIST_ITEMS_PANEL, false);
  }

return { __sfc: true,store, PlaylistItems, playlist, handleChange, goBackToPlaylist, PlaylistPreview, LayoutPlaylistItems }
}

})